import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./Slices/Slices/apiSliceMeat";
import handlechart from "./Slices/reducer";
import authReducer from "./Slices/authSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    handlechart: handlechart,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
